<template>
  <group-card title="Application Ownerships" icon="group" :tooltipText="tooltipText" :loading="isSaving">

    <md-dialog :md-active.sync="showIfUserIsAgentAndNoAgentAssignedToApplication" :md-click-outside-to-close="false" :md-close-on-esc="false">
        <md-dialog-content>
            <p class="message-height">No agent has been assigned to this application, would you like to assign yourself to this app?</p>
            <div class="action-buttons-cover">
                <md-dialog-actions class="action-buttons">
                    <md-progress-spinner :md-diameter="30" :md-stroke="3" md-mode="indeterminate" v-if="addingAgentToApplication"></md-progress-spinner>
                    <!-- <md-button class="md-success" :disabled="isUpdating" v-if="isStatusFail" @click="retryStatus()">Retry</md-button>
                    <md-button class="md-danger" @click="changeStatus('decline after failed')" :disabled="isUpdating">Decline</md-button> -->
                    <md-button class="" @click="addAgentToApplication('no')">No</md-button>
                    <md-button class="md-primary" @click="addAgentToApplication('yes')" :disabled="addingAgentToApplication">Yes</md-button>
                </md-dialog-actions>
            </div>
        </md-dialog-content>
    </md-dialog>

    <template slot="actions">
        <div class="property-list">
            <property-view name="Application created at">
                {{ application.loan.created_at | datetime }}
            </property-view>
            <property-view name="Application status updated at">
                {{ application.loan.status.updated_at | datetime }}
            </property-view>
        </div>
     </template>
    <div class="boxed-category all_owner_box" v-if="application.owners.length > 0">
      <div class="md-layout md-size-100">
        <div class="owner-list md-layout-item md-small-size-100 md-size-20" v-for="owner in application.owners" v-if="owner.role !='Partner'">
          <div class="input_with_table">
            <!-- Search Owners -->
            <search-text-input class="md-layout-item md-size-100"
                               :label="formattedLabel(owner.role)"
                               v-bind:value="owner.name | name"
                               :searcher="performSearch"
                               @select="setUserAndRole"
                               min-length="2"
                               clearable
                               @click="searchRole = owner.role"
                               :disabled="isDisabled(owner.role)"
            >
              <template v-slot="{ item }">
                {{ item.name }}
              </template>
            </search-text-input>
          </div>
        </div>
      </div>
    </div>
    <md-empty-state
      v-else
      class="small-empty-state"
      md-icon="close"
      md-label="Not available"
      md-description="This data is not available at this stage."
    />
  </group-card>
</template>

<script>
import filters from "@/components/utils/filters";
import ValidatedInputs from "@/components/ValidatedInput";
import GroupCard from "@/components/Cards/GroupCard";
import GroupCardRow from "@/components/Cards/GroupCardRow";
import PropertyView from "@/components/ApplicationSummary/PropertyView";
import {mapGetters} from "vuex";
import ConfirmDialog from "@/components/Dialogs/ConfirmDialog";
import AlertDialog from "@/components/Dialogs/AlertDialog";
import SearchTextInput from "../ValidatedInput/SearchTextInput";

export default {
  components: {
    SearchTextInput,
    ...ValidatedInputs,
    GroupCard,
    GroupCardRow,
    PropertyView,
    ConfirmDialog
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
  },
  data() {
    return{
        searchRole: null,
        isSaving: false,
        tooltipText: '<li>When beginning the application always make sure that the referrer has been filled in and that the agent name has been updated to yourself</li>'+
                    '<li>If there is a broker assigned or an agent, check if the lead is active</li>',
        showIfUserIsAgentAndNoAgentAssignedToApplication: false,
        addingAgentToApplication: false
    }
  },
  computed: {
    // internal reference to the v-model on this component, handles incomeing and outgoing changes
    application: {
      get() {
        return this.value;
      },
      set(application) {
        this.$emit("input", application);
      },
    },
    ...mapGetters({
      options: 'options',
      administrationUsers: 'administrationUsers',
      applicationStatus: 'application_status',
      applicationReferrer: "application_referrer",
      userHasRole: 'userHasRole',
      user: 'user'
    })
  },
  methods: {
    // make all filters available as methods
    ...filters,
    async performSearch(query) {
      let availableUsers = await axios.get(`/api/v1/administration/role_based_users/${query}/${this.searchRole}`);
      return availableUsers.data;
    },
    isDisabled(label) {
      return label === 'Referrer' && this.applicationReferrer.is_marketing_lead;
    },
    formattedLabel(ownerRole) {
      return this.isDisabled(ownerRole)
        ? `${ownerRole} (not editable)`
        : ownerRole;
    },
    async setUserAndRole(row) {
      if (!!this.application.loan.id) {
        if (await this.showNotification('Update Owner?', `Click Proceed to set ${row.name} as ${row.role} for this application.`)) {
          this.isSaving = true;
          try {
            await axios.post(`/api/v1/application/${this.application.loan.id}/add_multiple_owner`, {
              'owners': [row]
            }).then(async (res) => {
                // If Status/Stage is New or Call Centre then update status Broker - Assigned to Broker
                let current_status = this.application.loan.status.stage;
                if (((current_status == 'New' || current_status == 'Call Centre') && current_status != 'Broker') && row.role == 'Broker') {
                  try {
                      await this.$store.dispatch('update_application_status', {
                        application_id: this.application.loan.id,
                        stage: "Broker",
                        status: "Assigned To Broker",
                        reason: "Other",
                        comment: "",
                      });
                    } catch (error) {
                      this.showAlertDialog('Error', 'Error changing the status to: Assigned To Broker');
                    }
                }
                this.applicationStatus.dirty = false;
                await this.$store.dispatch('reload_application');
            })
          } catch (error) {
            this.showAlertDialog('Error', error.response.data);
          }
        }
        this.isSaving = false;
      } else {
        let target = this.application.owners.find(owner => owner.role === row.role);
        if (!!target) {
          target.name.firstname = row.name_detail.first_name;
          target.name.lastname = row.name_detail.last_name;
          target.email = row.email;
          target.phone = null;
          target.created_at = null;
          target.user_id = row.id;
        }
      }
    },
    showNotification(title, content, confirmText = 'Proceed', cancelText = 'Cancel') {
      return this.$modal.show(ConfirmDialog, {
        title: title,
        message: content,
        confirmText: confirmText,
        cancelText: cancelText,
      });
    },
    showAlertDialog(title, message) {
      return this.$modal.show(AlertDialog, { title, message });
    },
    async getDefaultOwnership() {
      // only fetch for new application.
      try {
        if (!!!this.application.loan.id) {
          await this.$store.dispatch('get_default_ownership');
        }
      } catch (e) {
        this.$modal.show(AlertDialog, {
          title: 'Error',
          message: 'There was a problem fetching the default ownership.',
        });
      }
    },
    checkIfUserIsAgentAndNoAgentAssignedToApplication() {
        // Check if user is an agent
        if (this.userHasRole('Agent')) {
            // Check if application has no agent assigned
            let current_status = this.application.loan.status.stage;
            if (this.application && this.application.owners && current_status == 'Call Centre') {
                let hasNoAgent = this.application.owners.find(owner => owner.role === "Agent" && owner.created_at == null);
                if (hasNoAgent) {
                    this.showIfUserIsAgentAndNoAgentAssignedToApplication = true;
                }
            }
        }
    },
    async addAgentToApplication(answer) {
        if (answer == 'yes') {
            this.addingAgentToApplication = true;
            const row = {
                email: this.user.email,
                id: this.user.id,
                name: this.user.first_name + ' ' + this.user.last_name,
                name_detail: {
                    first_name: this.user.first_name,
                    last_name: this.user.last_name,
                },
                role: "Agent"
            };
            // Update application to you use an agent
            try {
                await axios.post(`/api/v1/application/${this.application.loan.id}/add_multiple_owner`, {
                    'owners': [row]
                });
                this.applicationStatus.dirty = false;
                await this.$store.dispatch('reload_application');
                this.showIfUserIsAgentAndNoAgentAssignedToApplication = false;
            } catch (error) {
                this.showAlertDialog('Error', error.response.data);
            }

        } else {
            this.addingAgentToApplication = false;
            this.showIfUserIsAgentAndNoAgentAssignedToApplication = false;
        }
    }
  },
  filters: {
    // make all filters available as filters
    ...filters,
  },
  mounted() {
    this.getDefaultOwnership();
    this.checkIfUserIsAgentAndNoAgentAssignedToApplication();
  }
};
</script>
